import { useQuery } from '@tanstack/react-query';
import { getAlliance } from '../services/alliance.service';

interface UseMyAllianceOptions {
    /** Skip the fetch entirely — the Galaxy map only wants it once its Sun popup opens. Defaults to `true`. */
    enabled?: boolean;
    /** Poll on an interval — omit (or pass `false`) for a one-shot fetch (refetched on invalidation). */
    refetchInterval?: number | false;
}

/**
 * The viewer's own alliance (membership, role, roster) — `data` is `null`
 * when they're in none. Single shared query key/options so every caller
 * (Alliance page, Team-planet conversion CTA, Galaxy map's Sun Attack
 * quick-link, Team-planet fleet dispatch) reads and invalidates the SAME
 * cache entry instead of drifting `staleTime`s across copies.
 */
export function useMyAlliance({ enabled = true, refetchInterval }: UseMyAllianceOptions = {}) {
    return useQuery({
        queryKey: ['alliance', 'mine'],
        queryFn: () => getAlliance(),
        staleTime: 30_000,
        enabled,
        refetchInterval,
    });
}
